module.exports = function(h, row) {
    if (_.isEmpty(row.available_from)) {
        return <i>No time assigned</i>;
    } else {
        return moment(row.available_from, 'HH:mm:ss').format('h:mm A');
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/setting/discount/colums/available_from.jsx